class ScrollFade extends HTMLElement {
  connectedCallback() {
    this.gradientTop = this.querySelector('[data-gradient-top]');
    this.gradientBottom = this.querySelector('[data-gradient-bottom]');

    this.addEventListener('scroll', this.handleScroll.bind(this));
    this.handleScroll(); // Initial check
  }

  disconnectedCallback() {
    this.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  handleScroll() {
    const scrollTop = this.scrollTop;
    const maxScroll = 10; // Adjust this value to control fade distance

    // Calculate opacity for top gradient
    const opacityTop = Math.min(scrollTop / maxScroll, 1);

    // Calculate remaining scroll distance to bottom
    const remainingScroll = this.scrollHeight - this.clientHeight - scrollTop;

    // Calculate opacity for bottom gradient
    const opacityBottom = Math.min(remainingScroll / maxScroll, 1);

    if (this.gradientTop) {
      this.gradientTop.style.opacity = opacityTop;
    }

    if (this.gradientBottom) {
      this.gradientBottom.style.opacity = opacityBottom;
    }
  }
}

customElements.define('scroll-fade', ScrollFade);
